import Reflux from 'reflux';

const IndexerClusterActions = Reflux.createActions({
  'health': { asyncResult: true },
  'name': { asyncResult: true },
});

export default IndexerClusterActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/indexers/IndexerClusterActions.jsx